export enum EnPageNameEnum {
    Home = 'HOME',
    Announcements = 'ANNOUNCEMENTS',
    Investments = 'INVESTMENTS',
    Inbox = 'INBOX',
    Forms = 'FORMS',
    Statements = 'STATEMENTS',
    RepStatements = 'REPSTATEMENTS',
    ClientStatements = 'CLIENTSTATEMENTS',
    Taxes = 'TAX',
    ClientSearch = 'CLIENTSEARCH',
    Reports = 'REPORTS',
    Investors = 'INVESTORS',
    Proxy = 'PROXY',
    SecurityQuestion = 'SECURITYQUESTION',
    SecurityAnswers = 'SECURITY_ANSWERS',
    ForgotPassword = 'FORGOTPASSWORD',
    ForgotUsername = 'FORGOT_USERNAME',
    ChangePassword = 'CHANGEPASSWORD',
    UpdateAddress = 'UPDATEADDRESS',
    NewRegistrationInvestor = 'NEWREGISTRATION_INVESTOR',
    NewRegistrationRep = 'NEWREGISTRATION_REP',
    UserProfile = 'USERPROFILE',
    EditProfile = 'EDITPROFILE',
    ChangeActivationState = 'CHANGE_ACTIVATION_STATE',
    ActivateUser = 'ACTIVATEUSER',
    LinkAccount = 'LINK_ACCOUNT',
    Faq = 'FAQ',
    ResetPassword= 'RESETPASSWORD'
}

export enum EnUserTypes {
    Investor = 'I',
    Rep = 'R',
    Broker = 'B',
    Custodian = 'T',
    User = 'U',
    DupMail = 'D',
    Territory = 'Y'
}

